var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#10B981"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8162 12.707C22.0701 12.9737 22.0597 13.3957 21.793 13.6495L14.0893 20.9829C13.9577 21.1081 13.7808 21.1742 13.5993 21.166C13.4179 21.1577 13.2477 21.0758 13.128 20.9391L10.1651 17.5545C9.92254 17.2775 9.95052 16.8563 10.2276 16.6138C10.5046 16.3713 10.9258 16.3992 11.1683 16.6763L13.6734 19.5379L20.8737 12.6838C21.1404 12.4299 21.5624 12.4403 21.8162 12.707Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.fbef91fd88546f4945ed548730f5d322.svg";
export { ForwardRef as ReactComponent };